import { Chip } from "@mui/material";
import type { VendorStatus } from "../types";

type StatusStyle = { bg: string; fg: string };

const DEFAULT_STATUS_STYLE: StatusStyle = { bg: "#666", fg: "#FFFFFF" };

const STATUS_STYLES: Record<VendorStatus, StatusStyle> = {
  Active: { bg: "#0F5132", fg: "#FFFFFF" },
  Pending: { bg: "#F19E2B", fg: "#FFFFFF" },
  Blocked: { bg: "#DB382A", fg: "#FFFFFF" },
  Blacklisted: { bg: "#DB382A", fg: "#FFFFFF" },
};

type Props = { status: VendorStatus };

export function StatusBadge({ status }: Props) {
  const style = STATUS_STYLES[status] ?? DEFAULT_STATUS_STYLE;
  const label = typeof status === "string" && status ? status.toUpperCase() : "—";
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        bgcolor: style.bg,
        color: style.fg,
        fontWeight: 700,
        letterSpacing: 0.6,
        fontSize: 11,
      }}
    />
  );
}

export default StatusBadge;
